import { createFileRoute } from '@tanstack/react-router';
import { ImportReportPage } from '@web/modules/imports/report/import-report-page';

export const Route = createFileRoute('/_app/imports/$importId')({ component: ImportReportRoute });

function ImportReportRoute() {
  const { importId } = Route.useParams();
  return <ImportReportPage key={importId} importId={importId} />;
}
